// extracted by mini-css-extract-plugin
module.exports = {"rootArea":"ChapterEditingPage_rootArea__2e7OU","managingArea":"ChapterEditingPage_managingArea__6hcaW"};